export class SchemaSettings<T> {
    constructor(
        public readonly id: string,
        public readonly localizableFields: Array<keyof T> = [],
        public readonly fillabelFields: Array<keyof T> = []
    ) {
    }

    isFieldLocalizable(fieldName: keyof T) {
        return this.localizableFields?.includes(fieldName);
    }

    fillableLocalizableFields() {
        return this.localizableFields.filter(item => this.fillabelFields.indexOf(item) >= 0);
    }

    hasLocalizableFields() {
        return this.localizableFields && this.localizableFields.length > 0;
    }
}
